<mat-card class="session-timeout-card">
	<mat-card-title>
		<p>Your session will expire in:</p>
	</mat-card-title>
	<mat-card-content>
		<div class="countdown">
			{{ remainingSeconds }}
		</div>

		<p>seconds</p>
	</mat-card-content>

	<mat-card-actions class="actions-row">
		<button mat-button mat-raised-button color="primary" (click)="stayLoggedIn()">
			Keep me signed in
		</button>

		<span class="spacer"></span>

		<button mat-button mat-raised-button color="warn" (click)="logout()">
			Sign me out
		</button>
	</mat-card-actions>
</mat-card>